import React, { useEffect } from "react";

import { useKeycloak } from "@react-keycloak/web";
import { GetEquipmentDataQuery } from "components/gql/queris/GetEquipmentData";
import {
  getFirstInArray,
  getLocalStorageItem,
  isIdentical,
  isObjectEmpty,
  logGQLError,
} from "data/functions";
// import { useAuth } from "react-oidc-context";
import { GetAlertData } from "./AlertContext";
import { GetCInfo } from "./CompanyContext";
import { GetData } from "./DataContext";

export const CodeContext = React.createContext();

export const reducer = (state, action) => {
  switch (action.type) {
    case "addToArray": {
      let existCodes = state?.codes || [];
      let newCodes = [...existCodes];
      let newCode = action.code;

      let find = newCodes.find((item) => item?.ID === newCode?.ID);
      if (!find) {
        newCodes = [...newCodes, newCode];
      } else {
        find = newCode;
      }

      if (!isIdentical(existCodes, newCodes)) {
        return {
          ...state,
          codes: newCodes.sort((a, b) => {
            if (a?.unix > b?.unix) {
              return -1;
            }
            if (a?.unix < b?.unix) {
              return 1;
            }
            return 0;
          }),
        };
      } else return state;
    }
    case "addCode": {
      let existCode = state?.code || {};
      let newCode = action.code;

      if (!isIdentical(existCode, newCode)) {
        return {
          ...state,
          code: newCode,
        };
      } else return state;
    }
    case "deleteCode": {
      return {
        ...state,
        code: {},
      };
    }
    default:
      return state;
  }
};

export const initialState = {
  code: {},
  codes: [],
};

function CodeProvider({ children }) {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const [equipmentDataQuery] = GetEquipmentDataQuery();
  const { dataObj, forceSetDataObj } = GetData();
  const { cInfo } = GetCInfo();
  // const auth = useAuth();
  const { setAlert } = GetAlertData();
  const value = {
    addCode: React.useCallback(
      (code) =>
        dispatch({
          code: code,
          type: "addCode",
        }),
      []
    ),
    addToArray: React.useCallback(
      (code) =>
        dispatch({
          code: code,
          type: "addToArray",
        }),
      []
    ),
    code: state.code,
    // deleteCode: React.useCallback(
    //   (key, code) =>
    //     dispatch({
    //       // key: key,
    //       code: code,
    //       type: "deleteCode",
    //     }),
    //   [],
    // ),
    codes: state.codes,
    deleteCode: React.useCallback(
      (code) =>
        dispatch({
          code: code,
          type: "deleteCode",
        }),
      []
    ),
  };

  React.useEffect(() => {
    if (dataObj?.payType !== "self-service") {
      getCodes(
        dataObj?.token,
        cInfo?.UUID,
        dataObj?.usedEquipment?.ID || getLocalStorageItem("data_usedEquipment"),
        dataObj?.refreshRate,
        dataObj?.equipments,
        setAlert
      );
      const interval = setInterval(() => {
        getCodes(
          dataObj?.token,
          cInfo?.UUID,
          dataObj?.usedEquipment?.ID ||
            getLocalStorageItem("data_usedEquipment"),
          dataObj?.refreshRate,
          dataObj?.equipments,
          setAlert
        );
      }, (dataObj?.refreshRate || 3) * 1000);
      return () => clearInterval(interval);
    }

    // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
  }, [
    cInfo?.UUID,
    dataObj?.token,
    state.codes,
    dataObj?.payType,
    dataObj?.equipments,
    dataObj?.refreshRate,
    dataObj?.usedEquipment,
    setAlert,
  ]);

  // async function getCodes(token, company_uuid, equipment_id) {
  //   if (!token || !company_uuid || !equipment_id) return;
  //   let data = await getEquipmentData(token, company_uuid, equipment_id);

  //   if (!isObjectEmpty(data)) {
  //     if (Array.isArray(data)) {
  //       data.forEach((el) => value.addCode(el));
  //     } else {
  //       value.addCode(data);
  //     }
  //   }
  // }

  async function getCodes(
    token,
    company_uuid,
    equipment_id,
    rate = 3,
    equipments,
    setAlert
  ) {
    if (!token || !company_uuid) return;
    if (!equipment_id) {
      // if (!isObjectEmpty(equipments)) {
      //   setAlert("Не указано используемое оборудование!", "error");
      // }

      return;
    }
    let errCount = sessionStorage.getItem("equipmentErrCount");
    if (Number(errCount) > 5) {
      setTimeout(() => {
        sessionStorage.setItem(
          "equipmentErrCount",
          Number(errCount) > 0 ? Number(errCount) - 1 : 0
        );
      }, 10000);
      setAlert("Потеряно соединение с сервером..", "info", rate);
      return;
    }
    let { data, error } = await equipmentDataQuery({
      variables: {
        companyUuid: company_uuid,
        equipmentId: equipment_id,
      },
    });
    if (data && data?.payment_getEquipmentData) {
      sessionStorage.setItem("equipmentErrCount", 0);
      if (data?.payment_getEquipmentData?.orderUrl)
        dispatch({
          code: data?.payment_getEquipmentData,
          type: "addCode",
        });
      else
        dispatch({
          code: {},
          type: "addCode",
        });
    }
    if (error) {
      logGQLError("GetEquipmentData", error);

      sessionStorage.setItem("equipmentErrCount", Number(errCount) + 1);

      // setAlert("Потеряно соединение с сервером..", "info", rate);
      dispatch({
        code: {},
        type: "addCode",
      });
    }
  }

  return <CodeContext.Provider value={value}>{children}</CodeContext.Provider>;
}
export const GetCode = () => {
  const context = React.useContext(CodeContext);
  return context;
};

export { CodeProvider };

export async function getEquipmentData(
  access_token,
  company_uuid,
  equipment_id
) {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", "Bearer " + access_token);

  const requestOptions = {
    headers: myHeaders,
    method: "GET",
    // mode: "no-cors",
    redirect: "follow",
  };

  // return await fetch(
  //   "https://cloud.5-systems.ru/5systems/redirect.php?url=https://api.5systems.ru/auth/v1/oidc/login&method=POST",
  //   requestOptions
  // )
  return await fetch(
    `https://cloud.5-systems.ru/5systems/redirect.php?URL=https://api.5systems.ru/payment/v1/data/equipment&company_uuid=${company_uuid}&equipment_id=${equipment_id}&method=GET`,
    requestOptions
  )
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error(error);
      return {};
    });
}
